import { Loader as SharedLoader } from "alpha-ui";
const Loader = () => <SharedLoader />;
export default Loader;
